/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Text_Outline_OptionInputs */

const en_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Outline`)
};

const fr_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contour de texte`)
};

const de_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textgliederung`)
};

const it_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Struttura del testo`)
};

const ru_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Структура текста`)
};

const es_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquema de texto`)
};

const zh_cn2_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本大纲`)
};

const ja_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストアウトライン`)
};

const hi_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ की रूपरेखा`)
};

const pt_pt2_styles_text_outline_option = /** @type {(inputs: Styles_Text_Outline_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esboço do texto`)
};

/**
* | output |
* | --- |
* | "Text Outline" |
*
* @param {Styles_Text_Outline_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_text_outline_option = /** @type {((inputs?: Styles_Text_Outline_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Text_Outline_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_text_outline_option(inputs)
	if (locale === "de") return de_styles_text_outline_option(inputs)
	if (locale === "it") return it_styles_text_outline_option(inputs)
	if (locale === "ru") return ru_styles_text_outline_option(inputs)
	if (locale === "es") return es_styles_text_outline_option(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_text_outline_option(inputs)
	if (locale === "ja") return ja_styles_text_outline_option(inputs)
	if (locale === "hi") return hi_styles_text_outline_option(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_text_outline_option(inputs)
	return en_styles_text_outline_option(inputs)
});